"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatCurrency = void 0;
var _react = require("react");
var _constants = require("../constants");
var _hooks = require("../hooks");
var _internals = require("../internals");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns props `value` formatted as the currency.
 *
 * @see {@link FormatCurrencyProps} for the available props and options.
 * @example
  // basic usage
  <FormatCurrency value={1234.567} />

  // use a custom delimiter
  const Delimiter: FC = () => <br />;
  <FormatCurrency value={1234.567} options={{ doubleCurrencyDelimiter: <Delimiter /> }} />
 */
const FormatCurrency = ({
  children,
  value,
  options
}) => {
  const {
    culture,
    financialSet
  } = (0, _hooks.useCulture)();
  const {
    currencies
  } = (0, _internals.getFormattedCurrency)(value ?? children, culture, financialSet);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: currencies.filter(Boolean).flatMap(currency => [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
      children: currency
    }, `value-${currency}`), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
      children: options?.doubleCurrencyDelimiter ?? _constants.DEFAULT_DOUBLE_CURRENCY_DELIMITER
    }, `delimiter-${currency}`)]).slice(0, -1)
  });
};
exports.FormatCurrency = FormatCurrency;
//# sourceMappingURL=FormatCurrency.js.map